<template>
  <layout-main-inner title="订单详情">
    <el-form :model="outstock"
             label-position='top'>
      <layout-card-wrap hasHeaderSlot
                        v-loading="loading">
        <template slot="title">收货信息</template>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="客户名称:">{{outstock.dealerName}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收货方名称:">{{outstock.deliveryName}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话:">{{outstock.deliveryPhone}}</el-form-item>
          </el-col>
          <el-col :span="8"
                  v-if="outstock.outstockLevel === 1">
            <el-form-item label="收货地址:">
              {{outstock.provinceName || '未知'}}-{{outstock.cityName || '未知'}}-{{outstock.areaName || '未知'}}-{{outstock.detailedAddress}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="经销区域:">
              <div v-for="(item, index) in outstock.saleAreas"
                   :key="index">
                {{ item.provinceName }}/{{ item.cityName }}
                <span v-if="item.areaName">/{{ item.areaName }}</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </layout-card-wrap>

      <layout-card-wrap style="margin-top: 15px"
                        hasHeaderSlot
                        v-loading="loading">
        <template slot="title">订单明细</template>
        <el-table border
                  :data="outstock.productItems">
          <el-table-column label="商品名称"
                           min-width="200"
                           prop="productName"></el-table-column>
          <!-- <el-table-column label="备注"
                           min-width="180"
                           prop="productNameRemark">
          </el-table-column>
          <el-table-column label="商品类型"
                           min-width="80"
                           prop="categoryName"></el-table-column> -->
          <el-table-column label="赋码方式"
                           min-width="80">
            <template slot-scope="{row}">{{ row.codingType | codingType()}}</template>
          </el-table-column>
          <el-table-column label="订单数量"
                           prop="goodsCount"
                           min-width="100">
          </el-table-column>
        </el-table>
      </layout-card-wrap>
      <layout-card-wrap style="margin-top: 15px"
                        hasHeaderSlot
                        v-loading="loading">
        <template slot="title">出库单汇总</template>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="总订单数:">{{outstock.outstockOrderSummary.totalOrderCount}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="已完成订单数:">{{outstock.outstockOrderSummary.totalDoneOrderCount}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="累计商品数:">{{outstock.outstockOrderSummary.totalGoodsCount}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="累计出库数:">{{outstock.outstockOrderSummary.totalOutGoodsCount}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="累计退货数:">{{outstock.outstockOrderSummary.totalReturnGoodsCount}}</el-form-item>
          </el-col>
        </el-row>
      </layout-card-wrap>

      <layout-card-wrap style="margin-top: 15px"
                        hasHeaderSlot
                        v-loading="loading">
        <template slot="title">出库单明细</template>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="订单号:">{{outstock.orderNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品数:">{{outstock.goodsCount}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退货数:">{{outstock.returnGoodsCount}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="创建时间:">{{ outstock.createdTime | dateformat('YYYY-MM-DD HH:ss:mm')}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-table border
                    max-height="600px"
                    :data="outstock.outstocks">
            <el-table-column label="出库单号"
                             prop="outstockCode"></el-table-column>
            <el-table-column label="商品总数"
                             prop="outGoodsCount"></el-table-column>
            <el-table-column label="出库时间">
              <template slot-scope="{row}">{{ row.outstockTime | dateformat('YYYY-MM-DD HH:ss:mm')}}</template>
            </el-table-column>
            <el-table-column label="商品明细"
                             width="100">
              <template slot-scope="{row}">
                <el-button type="text"
                           @click="showOutstock(row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row style="margin-top: 15px">
          <el-table border
                    max-height="600px"
                    :data="outstock.goodsReturns">
            <el-table-column label="退货单号"
                             prop="goodsReturnCode"></el-table-column>
            <el-table-column label="商品总数"
                             prop="returnGoodsCount"></el-table-column>
            <el-table-column label="退货时间">
              <template slot-scope="{row}">{{ row.goodsReturnTime | dateformat('YYYY-MM-DD HH:ss:mm')}}</template>
            </el-table-column>
            <el-table-column label="商品明细"
                             width="100">
              <template slot-scope="{row}">
                <el-button type="text"
                           @click="showGoodsReturn(row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </layout-card-wrap>

      <layout-card-wrap hasHeaderSlot
                        style="margin-top: 15px"
                        v-for="(item, index) in outstock.subOutstockOrders"
                        :key="index"
                        v-loading="loading">
        <template slot="title">补单明细{{index+1}}</template>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="订单号:">{{item.orderNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品数:">{{item.goodsCount}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退货数:">{{item.returnGoodsCount}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="创建时间:">{{ item.createdTime | dateformat('YYYY-MM-DD HH:ss:mm')}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-table border
                    max-height="600px"
                    :data="item.outstocks">
            <el-table-column label="出库单号"
                             prop="outstockCode"></el-table-column>
            <el-table-column label="商品总数"
                             prop="outGoodsCount"></el-table-column>
            <el-table-column label="出库时间">
              <template slot-scope="{row}">{{ row.outstockTime | dateformat('YYYY-MM-DD HH:ss:mm')}}</template>
            </el-table-column>
            <el-table-column label="商品明细"
                             width="100">
              <template slot-scope="{row}">
                <el-button type="text"
                           @click="showOutstock(row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row style="margin-top: 15px">
          <el-table border
                    max-height="600px"
                    :data="item.goodsReturns">
            <el-table-column label="退货单号"
                             prop="goodsReturnCode"></el-table-column>
            <el-table-column label="商品总数"
                             prop="returnGoodsCount"></el-table-column>
            <el-table-column label="退货时间">
              <template slot-scope="{row}">{{ row.goodsReturnTime | dateformat('YYYY-MM-DD HH:ss:mm')}}</template>
            </el-table-column>
            <el-table-column label="商品明细"
                             width="100">
              <template slot-scope="{row}">
                <el-button type="text"
                           @click="showGoodsReturn(row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </layout-card-wrap>
    </el-form>
    <product-count-modal ref="modal" />
  </layout-main-inner>
</template>
<script>
import ProductCountModal from './busi/product-count-modal.vue'
export default {
  name: 'outstock-detail',
  components: { ProductCountModal },
  data () {
    return {
      loading: false,
      outstock: {
        outstockOrderSummary: {}
      }
    }
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    getoutstockorder () {
      this.$store.dispatch('outstock/getoutstockorder', {
        payload: {
          vendorId: this.$route.query.vendorId,
          outstockOrderId: this.$route.query.outstockOrderId
        },
        success: (res) => {
          this.outstock = {
            ...this.outstock,
            ...res.data
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    showOutstock (row) {
      this.$refs.modal.searchOutstock(row, '出库商品明细')
    },
    showGoodsReturn (row) {
      this.$refs.modal.searchGoodsreturn(row, '退货商品明细')
    }
  },
  mounted () {
    this.getoutstockorder()
  }
}
</script>
<style lang="stylus"></style>
